/**
 * Tenant-scoped content filtering (Phase D1).
 *
 * Legacy rule (DEV-safe, no migration required):
 * - Records with missing/empty `tenantId` are treated as belonging to `triglav`.
 * - Records with explicit `tenantId` must match the active tenant.
 *
 * Rationale: preserves all existing Triglav Firestore content while preventing
 * legacy/shared rows from appearing under `posta` or other tenants.
 */

import { DEFAULT_TENANT_ID } from '../platform/constants';

/** Normalize stored tenantId; absent values inherit default tenant. */
export function resolveContentTenantId(rawTenantId) {
  if (rawTenantId == null || rawTenantId === '') {
    return DEFAULT_TENANT_ID;
  }
  return String(rawTenantId);
}

/** Whether a content row belongs to the active tenant. */
export function matchesActiveTenant(item, activeTenantId) {
  const contentTenant = resolveContentTenantId(item?.tenantId);
  return contentTenant === activeTenantId;
}

/** Client-side filter applied after Firestore reads. */
export function filterByActiveTenant(items, activeTenantId) {
  return items.filter((item) => matchesActiveTenant(item, activeTenantId));
}

/** Always scope list queries by tenantId — required for D3 Firestore rules. */
export function shouldApplyServerTenantFilter(activeTenantId) {
  return Boolean(activeTenantId && String(activeTenantId).trim() !== '');
}
